// extracted by mini-css-extract-plugin
export default {"pageContent":"wrapper_pageContent__HNCVZ"};